/* =============================================================================
   The Slow Pencil — comportamento della landing
   -----------------------------------------------------------------------------
   Quattro cose, in quest'ordine: la galleria, il carosello, le FAQ, il carrello.
   Tutto vanilla: il tema non carica nessuna libreria.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------- 1. GALLERIE ---
     Due gallerie identiche (hero e offerta): il click su una miniatura cambia
     l'immagine grande del proprio gruppo. Il colore del bordo attivo e' diverso
     nelle due, e viaggia sul bottone stesso (data-sp-active).                */
  // Ogni galleria e' una striscia di 4 foto a scorrimento (scroll-snap):
  // tutte le foto sono gia' nella pagina, quindi cambiare foto e' istantaneo
  // (prima si cambiava img.src al click e la foto nuova si scaricava solo allora).
  function miniature(gruppo) {
    return document.querySelectorAll('[data-sp-thumb][data-sp-group="' + gruppo + '"]');
  }
  function evidenzia(gruppo, i) {
    miniature(gruppo).forEach(function (x) {
      x.style.borderColor = (+x.getAttribute('data-sp-thumb') === i)
        ? x.getAttribute('data-sp-active') : 'transparent';
    });
  }
  document.querySelectorAll('[data-sp-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      var gruppo = b.getAttribute('data-sp-group');
      var i = +b.getAttribute('data-sp-thumb');
      var striscia = document.querySelector('[data-sp-track="' + gruppo + '"]');
      if (striscia) striscia.scrollTo({ left: i * striscia.clientWidth, behavior: 'smooth' });
      evidenzia(gruppo, i);
    });
  });
  document.querySelectorAll('[data-sp-track]').forEach(function (striscia) {
    var gruppo = striscia.getAttribute('data-sp-track');
    var ultimo = 0, attesa = null;
    striscia.addEventListener('scroll', function () {
      if (attesa) return;
      attesa = requestAnimationFrame(function () {
        attesa = null;
        var i = Math.round(striscia.scrollLeft / Math.max(1, striscia.clientWidth));
        if (i !== ultimo) { ultimo = i; evidenzia(gruppo, i); }
      });
    }, { passive: true });
    // Frecce da tastiera quando la galleria ha il focus.
    striscia.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var n = striscia.children.length;
      var i = Math.min(n - 1, Math.max(0, ultimo + (e.key === 'ArrowRight' ? 1 : -1)));
      striscia.scrollTo({ left: i * striscia.clientWidth, behavior: 'smooth' });
    });
    // Trascinamento col mouse (sul telefono basta lo scroll nativo del dito).
    var giu = false, x0 = 0, s0 = 0;
    striscia.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      giu = true; x0 = e.clientX; s0 = striscia.scrollLeft;
      striscia.classList.add('sp-drag');
      striscia.setPointerCapture(e.pointerId);
    });
    striscia.addEventListener('pointermove', function (e) {
      if (giu) striscia.scrollLeft = s0 - (e.clientX - x0);
    });
    function fine(e) {
      if (!giu) return;
      giu = false;
      var w = striscia.clientWidth, d = striscia.scrollLeft - s0;
      var i = Math.round(s0 / w) + (Math.abs(d) > w * 0.15 ? (d > 0 ? 1 : -1) : 0);
      i = Math.min(striscia.children.length - 1, Math.max(0, i));
      striscia.classList.remove('sp-drag');
      striscia.scrollTo({ left: i * w, behavior: 'smooth' });
    }
    striscia.addEventListener('pointerup', fine);
    striscia.addEventListener('pointercancel', fine);
  });

  /* -------------------------------------------------------------- 2. FAQ ---
     Una aperta per volta. L'apertura e' una grid-template-rows da 0fr a 1fr:
     e' l'unico modo di animare un'altezza che non si conosce.                */
  function faqChiudi(box) {
    box.querySelector('[data-sp-faq-btn]').setAttribute('aria-expanded', 'false');
    box.querySelector('[data-sp-faq-body]').style.gridTemplateRows = '0fr';
    var i = box.querySelector('[data-sp-faq-icon]');
    i.style.transform = 'rotate(0deg)';
    i.style.background = '#F4E3CF';
    i.style.color = '#B8521A';
  }
  function faqApri(box) {
    box.querySelector('[data-sp-faq-btn]').setAttribute('aria-expanded', 'true');
    box.querySelector('[data-sp-faq-body]').style.gridTemplateRows = '1fr';
    var i = box.querySelector('[data-sp-faq-icon]');
    i.style.transform = 'rotate(45deg)';
    i.style.background = '#B8521A';
    i.style.color = '#F9F8F6';
  }
  var faqBox = document.querySelectorAll('[data-sp-faq]');
  faqBox.forEach(function (box) {
    box.querySelector('[data-sp-faq-btn]').addEventListener('click', function () {
      var era = box.querySelector('[data-sp-faq-btn]').getAttribute('aria-expanded') === 'true';
      faqBox.forEach(faqChiudi);
      if (!era) faqApri(box);
    });
  });
  if (faqBox.length) faqApri(faqBox[0]);      // la prima e' aperta, come nel design

  /* -------------------------------------------------- 3. CAROSELLO "DRAW" ---
     Scorre da solo, piano, all'infinito, e si ferma appena l'utente lo tocca.
     ⛔ Il movimento NON e' un'animazione CSS: e' lo scroll nativo della striscia
     spinto di mezzo pixel a frame. E' l'unico modo perche' il dito prenda il
     controllo senza che l'immagine salti — un transform animato e lo scroll del
     dito si combatterebbero. La lista e' duplicata (5 + 5): fatto un giro si
     torna indietro di un giro, e il salto e' invisibile perche' li' c'e' la
     stessa identica card.                                                    */
  (function carosello() {
    var VEL = 0.42;        // px a frame, ~25 px al secondo: deve essere lento
    var RIPRESA = 2500;    // ms di quiete prima che riparta da solo
    var el = document.querySelector('[data-drawtrack]');
    if (!el) return;
    // ⛔ `atteso` non e' un vezzo: l'evento 'scroll' NON arriva mentre si scrive
    // scrollLeft, arriva dopo, al frame seguente. Con un flag booleano alzato
    // attorno alla scrittura il carosello scambia il PROPRIO scroll per un tocco
    // dell'utente e si ferma per sempre dopo il primo pixel. Qui si ricorda il
    // valore scritto: se lo scroll arrivato e' quello, e' nostro.
    var giro = 0, ultimo = 0, atteso = -1, giu = false, x0 = 0, s0 = 0;
    var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    function fermo() { ultimo = Date.now(); }
    // ⛔ Il giro NON e' scrollWidth/2: dentro scrollWidth ci sono anche i due
    // padding della striscia, e meta' di quelli sfasa il salto di qualche pixel.
    // Si misura fra la prima card e la sesta, che e' la sua copia.
    function misura() {
      var c = el.children;
      var meta = c ? Math.floor(c.length / 2) : 0;   // Halloween: 6 + 6, la copia parte da meta'
      giro = (meta >= 2) ? c[meta].offsetLeft - c[0].offsetLeft : 0;
    }
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (e) {
      el.addEventListener(e, fermo, { passive: true });
    });
    el.addEventListener('scroll', function () {
      if (atteso < 0 || Math.abs(el.scrollLeft - atteso) > 2) fermo();
    }, { passive: true });
    el.addEventListener('pointerdown', function (ev) {      // trascinamento col mouse
      if (ev.pointerType !== 'mouse') return;
      giu = true; x0 = ev.clientX; s0 = el.scrollLeft;
      el.style.cursor = 'grabbing'; ev.preventDefault();
    });
    window.addEventListener('pointermove', function (ev) {
      if (!giu) return;
      el.scrollLeft = s0 - (ev.clientX - x0);
      atteso = el.scrollLeft; fermo();
    });
    window.addEventListener('pointerup', function () {
      giu = false; el.style.cursor = 'grab'; fermo();
    });
    window.addEventListener('resize', misura);
    misura();
    (function passo() {
      requestAnimationFrame(passo);
      if (!giro) { misura(); if (!giro) return; }
      if (!giu && !(mq && mq.matches) && Date.now() - ultimo > RIPRESA) el.scrollLeft += VEL;
      if (el.scrollLeft >= giro) el.scrollLeft -= giro;
      else if (el.scrollLeft < 0) el.scrollLeft += giro;
      atteso = el.scrollLeft;
    })();
  })();

  /* ---------------------------------------------------------- 4. CARRELLO ---
     ⛔ La pagina NON tiene un carrello suo: il modale e' solo la SCELTA degli
     addon. Il carrello vero e' quello di Shopify (AJAX Cart API), ed e' l'unico
     modo perche' l'aggiunta finisca nelle analytics e nel pixel: l'evento
     product_added_to_cart lo emette Shopify quando si passa di li', non noi.
     ⛔ Non aggiungere un evento a mano, o l'AddToCart si conta due volte.     */
  var radice = document.getElementById('sp-cart');
  if (!radice) return;

  var d = radice.dataset;
  var VAR = {
    core: parseInt(d.core, 10) || 0,
    addon: [parseInt(d.addon1, 10) || 0, parseInt(d.addon2, 10) || 0, parseInt(d.addon3, 10) || 0],
    bundle3: parseInt(d.bundle3, 10) || 0
  };
  var URL_CART = d.cartUrl || '/cart';
  var URL_ADD = d.addUrl || '/cart/add';
  var URL_CHANGE = d.changeUrl || '/cart/change';
  var URL_CHECKOUT = ((d.root === '/' ? '' : (d.root || '')).replace(/\/$/, '')) + '/checkout';

  /* --- diagnostica ---------------------------------------------------------
     ⛔ Una riga sola all'avvio, sempre: dice se il carrello e' vivo o no. Serve
     a chiudere in due secondi la domanda «perche' l'add to cart non compare
     nelle analytics?», che ha una sola causa vera — il prodotto non scelto
     nelle impostazioni del tema. Con ?spdebug=1 nell'indirizzo si vede anche
     ogni chiamata a Shopify con la sua risposta. */
  var DEBUG = /[?&]spdebug=1/.test(location.search);
  function log() {
    if (!DEBUG) return;
    var a = Array.prototype.slice.call(arguments);
    console.log.apply(console, ['[sp-cart]'].concat(a));
  }
  console[VAR.core > 0 ? 'info' : 'warn'](
    '[sp-cart] ' + (VAR.core > 0
      ? 'attivo — le aggiunte passano da Shopify e finiscono nelle analytics.'
      : 'SPENTO — nessun prodotto in Personalizza > Impostazioni tema > Cart and products. '
        + 'Il modale si apre ma Shopify non viene chiamato: nessun add-to-cart verra\' tracciato.'),
    { core: VAR.core, addon: VAR.addon, bundle3: VAR.bundle3, checkout: URL_CHECKOUT }
  );

  var overlay = radice.querySelector('[data-sp-overlay]');
  var pannello = radice.querySelector('[data-sp-panel]');
  var righe = Array.prototype.slice.call(radice.querySelectorAll('[data-sp-addon]'));
  var bottoneBundle = radice.querySelector('[data-sp-bundle]');
  var etichettaTotale = radice.querySelector('[data-sp-total]');
  var ancora = radice.querySelector('[data-sp-anchor]');
  var ctaCheckout = radice.querySelector('[data-sp-checkout-all]');
  var ctaCore = radice.querySelector('[data-sp-checkout-core]');

  var scelte = [false, false, false];
  var bundle = false;
  var occupato = false;
  var coda = Promise.resolve();

  function attivo() { return VAR.core > 0; }

  function post(url, corpo) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) {
      if (!r.ok) {
        return r.text().then(function (t) {
          throw new Error(url + '.js -> ' + r.status + ' ' + t.slice(0, 200));
        });
      }
      return r.json();
    }).then(function (j) {
      log(url + '.js OK', corpo, j);
      return j;
    });
  }
  function leggi() {
    return fetch(URL_CART + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js -> ' + r.status);
        return r.json();
      });
  }

  /* Porta il carrello di Shopify a contenere ESATTAMENTE `voluti`, uno a testa,
     senza toccare righe che non sono nostre.
     🔑 QUI STA LA DE-DUPLICA, ed e' una riga sola: add.js si chiama SOLO se
     quella variante nel carrello non c'e' gia'. Aprire e chiudere il modale
     dieci volte non aggiunge dieci articoli e non spara dieci AddToCart. Il
     togliere passa da change.js, che e' una rimozione e non falsa le aggiunte. */
  function allinea(voluti) {
    if (!attivo()) {
      console.warn('[sp-cart] nessun prodotto scelto nelle impostazioni del tema: Shopify non viene chiamato');
      return Promise.resolve();
    }
    var nostri = {};
    [VAR.core, VAR.bundle3].concat(VAR.addon).forEach(function (v) { if (v) nostri[v] = true; });
    var vuoi = voluti.filter(Boolean).map(String);
    return leggi().then(function (carrello) {
      var dentro = {};
      (carrello.items || []).forEach(function (i) { dentro[String(i.variant_id)] = i; });
      var catena = Promise.resolve();
      Object.keys(dentro).forEach(function (vid) {          // 1. via il non piu' scelto
        if (nostri[vid] && vuoi.indexOf(vid) < 0) {
          catena = catena.then(function () { return post(URL_CHANGE, { id: vid, quantity: 0 }); });
        }
      });
      vuoi.forEach(function (vid) {                          // 2. dentro cio' che manca
        var riga = dentro[vid];
        if (!riga) {
          catena = catena.then(function () {
            return post(URL_ADD, { items: [{ id: Number(vid), quantity: 1 }] });
          });
        } else if (riga.quantity !== 1) {
          catena = catena.then(function () { return post(URL_CHANGE, { id: vid, quantity: 1 }); });
        }
      });
      return catena;
    });
  }

  // Una coda sola: due clic ravvicinati non devono leggere lo stesso carrello e
  // scrivere due volte la stessa aggiunta.
  function accoda(lavoro) {
    // La coda non deve MAI restare rotta (una promise rifiutata blocca tutte le
    // successive), ma chi ha chiesto il lavoro deve sapere com'e' andata: si
    // risolve sempre, con `true` se e' filato liscio.
    var esito = coda.then(lavoro).then(function () { return true; }, function (e) {
      console.warn('[sp-cart] chiamata a Shopify fallita:', e && e.message ? e.message : e);
      return false;
    });
    coda = esito;
    return esito;
  }

  function scelti() {
    if (bundle) return VAR.bundle3 ? [VAR.bundle3] : VAR.addon.slice();
    return VAR.addon.filter(function (v, i) { return scelte[i]; });
  }

  /* ------------------------------------------------------------- disegno --- */
  function box(el, acceso) {
    el.textContent = acceso ? '✓' : '';
    el.style.background = acceso ? '#B8521A' : '#FFFFFF';
    el.style.color = acceso ? '#F9F8F6' : 'transparent';
    el.style.border = '2px solid ' + (acceso ? '#B8521A' : '#CBC2B4');
  }
  function ridisegna() {
    righe.forEach(function (r, i) {
      var acceso = bundle || scelte[i];
      box(r.querySelector('[data-sp-box]'), acceso);
      r.style.borderColor = acceso ? '#D9B7AB' : '#E7E2D9';
      r.setAttribute('aria-pressed', acceso ? 'true' : 'false');
    });
    box(bottoneBundle.querySelector('[data-sp-box]'), bundle);
    bottoneBundle.style.borderColor = bundle ? '#B8521A' : '#D8D0C4';
    bottoneBundle.setAttribute('aria-pressed', bundle ? 'true' : 'false');
    var quanti = scelte.filter(Boolean).length;
    // ⛔ NIENTE ARITMETICA QUI. I nove totali arrivano gia' scritti da Liquid,
    // nella valuta del mercato del visitatore (data-t000 … data-t111, data-tb).
    // Un `27 + 9` scritto qui resterebbe in dollari anche con Shopify Markets
    // acceso, e la pagina direbbe $36 dove il checkout dice € 33,50.
    if (d.money === '1') {
      var chiave = bundle ? 'tb'
        : 't' + (scelte[0] ? 1 : 0) + (scelte[1] ? 1 : 0) + (scelte[2] ? 1 : 0);
      etichettaTotale.textContent = d[chiave] || d.t000 || '';
    } else {
      // ripiego di quando i prodotti non sono ancora scelti: e' il testo di
      // sempre, ed e' vero finche' si vende in dollari.
      etichettaTotale.textContent = '$' + (27 + (bundle ? 21 : quanti * 9));
    }
    // ⛔ Il barrato sparisce appena c'e' un addon: lo sconto vale solo sul
    // prodotto base, e un prezzo pieno accanto a un totale con addon
    // implicherebbe una matematica sbagliata.
    ancora.style.display = (bundle || quanti) ? 'none' : '';
  }

  /* -------------------------------------------------------- apri e chiudi --- */
  function apri(e) {
    if (e) e.preventDefault();
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    // il prodotto base entra nel carrello vero SUBITO: e' qui che Shopify
    // registra l'AddToCart. Gli addon no — restano spunte finche' non si va al
    // checkout, cosi' spuntare e togliere non genera eventi.
    accoda(function () { return allinea([VAR.core]); });
  }
  // ✕, sfondo ed Esc chiudono e basta: il carrello di Shopify resta com'e', e
  // riaprendo non si aggiunge niente una seconda volta.
  function chiudi() {
    overlay.hidden = true;
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-sp-open-cart]').forEach(function (b) {
    b.addEventListener('click', apri);
  });
  // 🛒 22/10 (utente): l'icona del carrello nell'header apre QUESTO modale (quello degli add-on). Da li' NON si aggiunge
  // niente: si apre e basta, con le spunte allineate a cio' che e' gia' nel carrello vero. Il prodotto base entra solo
  // con «Continue to Checkout» (allinea → add.js, come sempre). ⛔ Niente eventi a mano: il pixel non cambia.
  function vedi(e) {
    if (e) e.preventDefault();
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    if (!attivo()) return;
    accoda(function () {
      return leggi().then(function (carrello) {
        var dentro = {};
        (carrello.items || []).forEach(function (i) { dentro[String(i.variant_id)] = true; });
        bundle = !!(VAR.bundle3 && dentro[String(VAR.bundle3)]);
        scelte = bundle ? [false, false, false] : VAR.addon.map(function (v) { return !!(v && dentro[String(v)]); });
        ridisegna();
      });
    });
  }
  document.querySelectorAll('[data-sp-view-cart]').forEach(function (b) {
    b.addEventListener('click', vedi);
  });
  radice.querySelectorAll('[data-sp-close]').forEach(function (b) {
    b.addEventListener('click', chiudi);
  });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) chiudi(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) chiudi();
  });

  righe.forEach(function (r, i) {
    r.addEventListener('click', function () {
      if (bundle) {                       // togliere uno dal pacchetto lo scioglie
        bundle = false;
        scelte = [true, true, true];
        scelte[i] = false;
      } else {
        scelte[i] = !scelte[i];
      }
      ridisegna();
    });
  });
  bottoneBundle.addEventListener('click', function () {
    bundle = !bundle;
    scelte = [false, false, false];
    ridisegna();
  });

  /* ------------------------------------------------------------ checkout --- */
  function vai(voluti) {
    if (occupato) return;
    occupato = true;
    ctaCheckout.textContent = 'One moment\u2026';
    accoda(function () { return allinea(voluti); }).then(function (ok) {
      // ⛔ Se l'allineamento e' fallito NON si va al checkout: si arriverebbe a
      // un carrello vuoto, Shopify rimanderebbe a /cart e l'evento
      // checkout_started non partirebbe mai. Meglio fermarsi e dirlo.
      if (!attivo()) {
        console.warn('[sp-cart] checkout non eseguito: manca il prodotto in Personalizza > Impostazioni tema > Cart and products');
      }
      if (attivo() && ok) {
        log('vado al checkout', URL_CHECKOUT);
        // Il popup (sp-popup) deve sapere la scelta FINALE, add-on compresi: col suo
        // timer da 1,5 s il redirect arrivava prima e la mail del carrello partiva col
        // solo prodotto base (trovato il 02/10). Gli si passa la lista, non deve rileggerla.
        try { document.dispatchEvent(new CustomEvent('sp:checkout', { detail: { variants: voluti.filter(Boolean).map(String) } })); } catch (err) {}
        // 🔑 Un solo passo in piu' prima del redirect, ed e' quello che salva il
        // Purchase: spTagCart() scrive _fbp/_fbc/external_id dentro il carrello
        // come attributi nascosti, cosi' finiscono nell'ordine e il webhook
        // orders/paid puo' mandare a Meta una vendita GIA' attribuita al click,
        // senza dipendere dal browser del cliente. Vive in snippets/meta-pixel.
        // ⛔ Non si aspetta piu' di 1,2 s: il checkout non si fa attendere.
        var vaiOra = function () { window.location.href = URL_CHECKOUT; };
        var marca = window.spTagCart ? window.spTagCart() : null;
        if (marca && marca.then) {
          var partito = false;
          var una = function () { if (!partito) { partito = true; vaiOra(); } };
          marca.then(una, una);
          setTimeout(una, 1200);
        } else {
          vaiOra();
        }
        return;
      }
      occupato = false;
      ctaCheckout.textContent = 'Continue to Checkout';
    });
  }
  ctaCheckout.addEventListener('click', function (e) {
    e.preventDefault();
    vai([VAR.core].concat(scelti()));
  });
  // "No thanks": checkout col solo prodotto base — e se in carrello erano finiti
  // degli addon da un giro precedente, allinea() li toglie.
  ctaCore.addEventListener('click', function (e) {
    e.preventDefault();
    vai([VAR.core]);
  });

  ridisegna();
})();
